import { useTheme } from '@mui/material';

import { ChartConfig, ChartType } from 'types/charts';

import { useCostReportContext } from '../../../../../../../cost-report/hooks/useCostReportContext';
import { CostReportChartType } from '../../../../../../../cost-report/types/costOverTime';

export const usePodCountChart = (): ChartConfig[] => {
  const theme = useTheme();
  const { chartType } = useCostReportContext();

  if (chartType === CostReportChartType.AREA) {
    return [
      {
        type: ChartType.AREA,
        enabled: true,
        config: {
          dataKey: 'total',
          fill: theme.palette.grey[700],
          name: 'Total pod count',
        },
      },
    ];
  }

  return [
    {
      type: ChartType.BAR,
      enabled: true,
      config: {
        dataKey: 'total',
        fill: theme.palette.grey[700],
        barSize: 16,
        maxBarSize: 20,
        name: 'Total pod count',
      },
      xAxisId: 0,
      stackId: 'a',
    },
  ];
};
